export function buildVCard(card) {
  const lines = ["BEGIN:VCARD", "VERSION:3.0", `FN:${card.name || ""}`];
  if (card.name) {
    const parts = card.name.trim().split(" ");
    const last = parts.length > 1 ? parts.slice(1).join(" ") : "";
    lines.push(`N:${last};${parts[0]};;;`);
  }
  if (card.organization) lines.push(`ORG:${card.organization}`);
  if (card.profession) lines.push(`TITLE:${card.profession}`);
  if (card.phone) lines.push(`TEL;TYPE=CELL:${card.phone}`);
  if (card.whatsapp) lines.push(`TEL;TYPE=VOICE:${card.whatsapp}`);
  if (card.email) lines.push(`EMAIL;TYPE=INTERNET:${card.email}`);
  if (card.website) lines.push(`URL:${card.website}`);
  if (card.brief) lines.push(`NOTE:${card.brief.replace(/\n/g, " ")}`);
  lines.push("END:VCARD");
  return lines.join("\n");
}

export function downloadVCard(card) {
  const blob = new Blob([buildVCard(card)], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(card.name || "contacto").replace(/\s+/g, "_")}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function shareCard(shareUrl, name) {
  const data = {
    title: `${name} · XUMA`,
    text: `Conoce mi tarjeta digital`,
    url: shareUrl,
  };
  if (navigator.share) {
    try {
      await navigator.share(data);
      return "shared";
    } catch {
      return "cancelled";
    }
  }
  try {
    await navigator.clipboard.writeText(shareUrl);
    return "copied";
  } catch {
    return "error";
  }
}
